;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import {
	getFreemiumTrialLastDayParts,
	pacificStartOfDay,
} from "@/lib/services/tier/compute-tier-expires-at";
import { TIER_TIMEZONE } from "@/lib/services/tier/tier-constants";

export function formatPacificDate(date: Date): string {
	return new Intl.DateTimeFormat("en-US", {
		dateStyle: "medium",
		timeZone: TIER_TIMEZONE,
	}).format(date);
}

export function formatFreemiumTrialEndDate({
	expiresAt,
}: {
	expiresAt: Date;
}): string {
	const lastDay = getFreemiumTrialLastDayParts({ expiresAt });
	return formatPacificDate(pacificStartOfDay(lastDay));
}
